import React from 'react';
import { GroupLabel } from './GroupLabel';
import { NavigationList } from './NavigationList';
import { MainNavigationGroupProps } from '../../MainNavigationTypes';

/**
 * Grouped navigation lists in main navigation
 */
export function MainNavigationGroup({
  groupLabel,
  navItems,
  fetchSubPanel,
  panelLevel,
  activeOpenButtonId,
  setActiveOpenButtonId,
}: MainNavigationGroupProps) {
  return (
    <div className="main-navigation__group">
      {groupLabel && <GroupLabel groupLabel={groupLabel} />}
      <NavigationList
        navItems={navItems}
        groupLabel={groupLabel}
        fetchSubPanel={fetchSubPanel}
        panelLevel={panelLevel}
        activeOpenButtonId={activeOpenButtonId}
        setActiveOpenButtonId={setActiveOpenButtonId}
      />
    </div>
  );
}
